import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
} from '@chakra-ui/react';
import { VideoLibraryArticlesList } from '@/features/Quiz/components/VideoLibraryArticlesList';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onSelectArticle: (domainId: number, sectionId?: number, title?: string) => void;
};

/** Article picker modal used only by `/quiz/create?libraryType=VIDEO`. */
export const VideoLibraryArticlesModal = ({ isOpen, onClose, onSelectArticle }: Props) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="4xl">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Articles</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VideoLibraryArticlesList onSelectArticle={onSelectArticle} />
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="blue" mr={3} onClick={onClose}>
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
